import { UAParser } from 'ua-parser-js'
import { compare, applyPatch } from 'fast-json-patch'

const uap = new UAParser()

export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

export function clone<T>(input: T): T {
  return JSON.parse(JSON.stringify(input))
}

export function useBrowser(): Record<string, boolean> {
  const isChrome = uap.getBrowser().name?.includes('Chrome') || false
  const isFirefox = uap.getBrowser().name?.includes('Firefox') || false
  const isSafari = uap.getBrowser().name?.includes('Safari') || false

  return { isChrome, isFirefox, isSafari }
}

export function deepPatch<T extends object | any[]>(item: T, newItem: T) {
  applyPatch(item, compare(item, newItem))
}

export const slugify = (text: string) => {
  return text.trim().toLowerCase().replace(/\s+/g, '-')
}

export function openMarketingHub(utmSource: string, itineraryMetaLink?: string) {
  const url = new URL('https://marketinghub.tourhero.com/')
  url.searchParams.set('utm_source', utmSource)
  url.searchParams.set('utm_medium', 'banner')
  if (itineraryMetaLink) {
    url.searchParams.set('itinerary_url', new URL(itineraryMetaLink, window.location.origin).toString())
  }
  window.open(url.toString(), '_blank')
}
